// extracted by mini-css-extract-plugin
export default {"room_wrap":"style_room_wrap__wd0h5","room_left_wrap":"style_room_left_wrap__bDMjS","room_center_wrap":"style_room_center_wrap__SsCh6"};